(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-hero"] && !Shopify.designMode) return;
  try {
    
  class Slideshow extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController(); const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('[data-slide-item]')]; this.index = 0;
      this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelectorAll('[data-slide-index]').forEach(b => b.addEventListener('click', () => this.show(Number(b.dataset.slideIndex)), {signal}));
      this.querySelector('[data-pause]')?.addEventListener('click', e => { this.paused = !this.paused; e.currentTarget.textContent = this.paused ? '▶' : 'Ⅱ'; e.currentTarget.setAttribute('aria-label', this.paused ? 'Reproducir' : 'Pausa'); this.show(this.index); }, {signal});
      this.addEventListener('keydown', e => {if (e.key === 'ArrowRight') this.show(this.index + 1);if (e.key === 'ArrowLeft') this.show(this.index - 1);}, {signal});
      this.addEventListener('focusin', () => clearTimeout(this.timer), {signal});
      this.addEventListener('focusout', () => this.schedule(), {signal});
      this.addEventListener('pointerdown', e => {this.x = e.clientX;}, {signal});
      this.addEventListener('pointerup', e => {if (Math.abs(e.clientX-this.x)>50) this.show(this.index+(e.clientX<this.x?1:-1));}, {signal});
      document.addEventListener('shopify:block:select', e => {const i=this.slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0){this.paused=true;this.show(i);}}, {signal});
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting; if(this.visible) this.show(this.index);else {clearTimeout(this.timer);this.querySelectorAll('video').forEach(v=>v.pause());}});
      this.observer.observe(this); this.show(0);
    }
    schedule() {clearTimeout(this.timer);if(!this.paused && this.visible && this.slides.length>1 && !this.contains(document.activeElement)) this.timer=setTimeout(()=>this.show(this.index+1),Number(this.dataset.speed||5)*1000);}
    show(index) {
      if(!this.slides.length)return;clearTimeout(this.timer);this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active)); const v=slide.querySelector('video');if(v){v.pause();if(active && this.visible){const src=v.querySelector('source[data-src]');if(src){src.src=src.dataset.src;src.removeAttribute('data-src');v.load();}if(!this.paused){v.play().catch(()=>{});v.onended=()=>this.show(this.index+1);}}}});
      this.querySelectorAll('[data-slide-index]').forEach((b,i)=>{b.classList.toggle('active',i===this.index);b.setAttribute('aria-pressed',String(i===this.index));});
      this.schedule();
    }
    disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.controller?.abort();this.controller=null;this.querySelectorAll('video').forEach(v=>v.pause());}
  }

if(!customElements.get('lm-slideshow'))customElements.define('lm-slideshow',Slideshow);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nm-ai-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nm-ai-reviews')) {
    customElements.define('nm-ai-reviews', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const track = this.querySelector('.nm-reviews__track');
        const buttons = this.querySelectorAll('[data-direction]');
        const update = () => {
          buttons[0].disabled = track.scrollLeft <= 2;
          buttons[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
        };
        const move = direction => {
          const card = track.querySelector('article');
          if (!card) return;
          track.scrollBy({left:direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        };
        buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), {signal}));
        track.addEventListener('scroll', update, {signal, passive:true});
        track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        }, {signal});
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('article');
          if (card) track.scrollTo({left:card.offsetLeft - track.offsetLeft,behavior:'instant'});
        }, {signal});
        this.classList.add('nm-reviews--ready');
        update();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
